import Footer from "../../helperComponents/Footer/Footer";
import Header from "../../helperComponents/Header/header";
import PreFooter from "../../helperComponents/PreFooter/Prefooter";
import { useMediaQuery } from "react-responsive";
import './gallery.scss';
import { supabase } from "../../supabaseClient";
import GalleryGrid from "./galleryGrid/GalleryGrid";
import { useEffect, useState } from "react";
import SplitType from "split-type";
import gsap from "gsap";


// export default function Gallery() {
//     const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
//     const isAlmostMediumScreen = useMediaQuery({ query: '(max-width: 1212px)' });
//     const [isAssetsLoaded, setIsAssetsLoaded] = useState(false);

//     useEffect(() => {
//         const videoContainer = document.querySelector('.videoContainer');
//         const mainContainer = document.querySelector('.gallery__container');

//         setTimeout(() => {
//             gsap.to(videoContainer, {
//                 duration: 1,
//                 scale: 0.8,
//                 opacity: 0,
//                 ease: "power4.inOut",
//                 onComplete: () => {
//                     setIsAssetsLoaded(true);
//                     gsap.fromTo(mainContainer, {
//                         opacity: 0,
//                         scale: 0.9
//                     }, {
//                         duration: 1,
//                         opacity: 1,
//                         scale: 1,
//                         ease: "power1.inOut"
//                     });
//                 }
//             });
//         }, 9000);


//     }, []);


//     useEffect(() => {
//         const char = new SplitType('.gallery__containerText1');
//         const tl1 = gsap.timeline();

//         tl1.to(".gallery__containerText1", {
//             duration: .6,
//             y: 0,
//             height: "fit-content",// Or an appropriate maximum height
//             clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
//             ease: "power1.inOut",
//             opacity: 1,
//             stagger: {
//                 amount: 0.3
//             }
//         }).to(".char", {
//             duration: .7,
//             y: 0,
//             ease: "power4.inOut",
//             stagger: {
//                 amount: 0.3
//             }
//         });
//     }, [isAssetsLoaded]);

//     // Add a separate useEffect for main container animation
//     useEffect(() => {
//         const char = new SplitType('.gallery__containerText2');
//         const mainContainer = document.querySelector('.gallery__container');
//         gsap.from(mainContainer, {
//             opacity: 0,
//             scale: 0.9,
//             duration: 1,
//             ease: "power4.inOut"
//         });

//         // Your existing text animations...
//         const tl1 = gsap.timeline();
//         tl1.to(".gallery__containerText2", {
//             duration: 1,
//             x: 0,
//             opacity: 1,
//             width: '40%',
//             stagger: {
//                 amount: 0.3
//             }
//         }).to(".gallery__containerBreaker", {
//             duration: .5,
//             opacity: 1,
//             ease: "power4.inOut",
//             stagger: {
//                 amount: 0.3
//             }
//         })

//     }, [isAssetsLoaded]);

//     useEffect(() => {
//         const char = new SplitType('.gallery__containerText11');
//         const tl1 = gsap.timeline();

//         tl1.to(".gallery__containerText11", {
//             duration: 1,
//             y: 0,
//             height: "fit-content",// Or an appropriate maximum height
//             clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
//             ease: "power4.inOut",
//             opacity: 1,
//             stagger: {
//                 amount: 0.3
//             }
//         }).to(".char", {
//             duration: .7,
//             y: 0,
//             ease: "power4.inOut",
//             stagger: {
//                 amount: 0.3
//             }
//         })
//     }, []);


//     return (
//         isAssetsLoaded ? <main className="gallery__container">
//             <Header isHomepage={false} />
//             <section className="gallery__container__main" style={{ padding: isMediumScreen ? '0 16px' : '0 70px', marginTop: isMediumScreen ? '80px' : '150px' }}>
//                 <section className="gallery__container__main1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
//                     <div style={{ fontWeight: 500, lineHeight: '110px', gap: '8px', }}>
//                         <p className="gallery__containerText1" style={{ fontStyle: 'italic', fontSize: isMediumScreen ? "42px" : '120px', }}>
//                             Gallery
//                         </p>
//                         <p className="gallery__containerText11" style={{ fontSize: isMediumScreen ? "20px" : '80px', bottom: '28px', position: 'relative', }}>({(galleryArray.length)})</p>
//                     </div>
//                     <p className="gallery__containerText2" style={{ marginBottom: isMediumScreen ? "75px" : '140px', marginTop: isMediumScreen ? "28px" : '70px', lineHeight: '30px', fontSize: '20px', fontWeight: 400, width: isMediumScreen ? '100%' : '40px', textAlign: 'center', }}>Immerse yourself in captivating memories crafted & created by Dudu's World Entertainment.</p>
//                     <hr className="gallery__containerBreaker" style={{ background: "#E3D4CE", width: '100%', height: '1px', }}></hr>
//                 </section>
//                 <GalleryGrid galleryArray={galleryArray} />
//             </section>
//             <PreFooter />
//             <Footer />
//         </main >
//             :
//             <div className="videoContainer">
//                 <video
//                     className="video-background"
//                     autoPlay
//                     loop
//                     muted
//                     playsInline
//                 >
//                     <source
//                         src='https://res.cloudinary.com/dqgtosjsg/video/upload/v1737807447/Untitled_video_-_Made_with_Clipchamp_qjxuo6.mp4'
//                         type="video/mp4"
//                     />
//                 </video>
//                 <div className="content-overlay">
//                     <p className="content-details">
//                         come, walk through our catalogue of memories
//                     </p>
//                 </div>
//             </div>
//     )
// }


export default function Gallery() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    const [galleryData, setGalleryData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGallery = async () => {
            const { data, error } = await supabase
                .from('gallery_sections')
                .select(`
                    title, description, created_at,
                    gallery_images (
                        cloudinary_url, is_visible, created_at
                    )
                `)
                .order('created_at', { ascending: false });

            if (!error && data) {
                const optimizeUrl = (url) => url ? url.replace('/upload/', '/upload/q_auto,f_auto,w_800/') : url;
                
                const formattedData = data.map(section => ({
                    title: section.title,
                    description: section.description,
                    images: (section.gallery_images || [])
                        .filter(img => img.is_visible)
                        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                        .map(img => optimizeUrl(img.cloudinary_url))
                }));
                setGalleryData(formattedData.filter(s => s.images.length > 0));
            }
            setLoading(false);
        };
        fetchGallery();
    }, []);


    useEffect(() => {
        if (loading) return;
        new SplitType('.gallery__containerText1');
        const tl1 = gsap.timeline();

        tl1.to(".gallery__containerText1", {
            duration: .5,
            y: 0,
            height: "fit-content",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            ease: "power1.inOut",
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .5,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        }).to(".gallery__container__grid", {
            duration: .5,
            opacity: 1,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        });
    }, [loading]);

    // Add a separate useEffect for main container animation
    useEffect(() => {
        if (loading) return;
        new SplitType('.gallery__containerText2');

        // Your existing text animations...
        const tl1 = gsap.timeline();
        tl1.to(".gallery__containerText2", {
            duration: .5,
            x: 0,
            opacity: 1,
            width: isMediumScreen ? '100%' : '40%',
            stagger: {
                amount: 0.3
            }
        }).to(".gallery__containerBreaker", {
            duration: .5,
            opacity: 1,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        })

    }, [loading, isMediumScreen]);

    useEffect(() => {
        if (loading) return;
        new SplitType('.gallery__containerText11');
        const tl1 = gsap.timeline();

        tl1.to(".gallery__containerText11", {
            duration: .5,
            y: 0,
            height: "fit-content",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            ease: "power4.inOut",
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        }).to(".char", {
            duration: .5,
            y: 0,
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        })
    }, [loading]);

    const totalImages = galleryData.reduce((sum, section) => sum + section.images.length, 0);


    return (
        <>
            <main className="gallery__container">
                <Header isHomepage={false} />
                <section className="gallery__container__main" style={{
                    padding: isMediumScreen ? '0 16px' : '0 70px',
                    marginTop: isMediumScreen ? '80px' : '150px'
                }}>
                    <section className="gallery__container__main1" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{ fontWeight: 500, lineHeight: '110px', gap: '8px' }}>
                            <p className="gallery__containerText1" style={{
                                fontStyle: 'italic',
                                fontSize: isMediumScreen ? "42px" : '120px'
                            }}>
                                Gallery
                            </p>
                            <p className="gallery__containerText11" style={{
                                fontSize: isMediumScreen ? "20px" : '80px',
                                bottom: '28px',
                                position: 'relative'
                            }}>({totalImages})</p>
                        </div>
                        <p className="gallery__containerText2" style={{
                            marginBottom: isMediumScreen ? "75px" : '140px',
                            marginTop: isMediumScreen ? "28px" : '70px',
                            lineHeight: '30px',
                            fontSize: '20px',
                            fontWeight: 400,
                            width: isMediumScreen ? '100%' : '40%',
                            textAlign: 'center'
                        }}>
                            Immerse yourself in captivating memories crafted & created by Dudu's World Entertainment.
                        </p>
                        <hr className="gallery__containerBreaker" style={{
                            background: "#E3D4CE",
                            width: '100%',
                            height: '1px'
                        }} />
                    </section>
                    <section className="gallery__container__grid">
                        <GalleryGrid galleryArray={galleryData} loading={loading} />
                    </section>
                </section>
                <PreFooter />
                <Footer />
            </main>
        </>
    );
}